export default __webpack_public_path__ + "static/media/accentureciie.048962bc.png";